import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import styled from 'styled-components';

export type ScopeTabsProps = TabsProps;

/** Branded antd Tabs — replaces former App.tsx ConfigProvider Tabs tokens. */
export const ScopeTabs = styled(Tabs)`
  font-family: var(--font-family);

  .ant-tabs-tab {
    padding: 12px 0 !important;
    margin: 0 !important;
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin-inline-start: 32px !important;
  }

  .ant-tabs-tab-btn {
    display: inline-flex !important;
    align-items: center !important;
    white-space: nowrap !important;
    font-family: var(--font-family) !important;
    font-size: var(--font-size-base) !important;
    font-weight: 400 !important;
    line-height: 1.5715 !important;
    color: var(--color-text-muted, #5a6a6a) !important;
    transition: color 0.2s;
  }

  .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: var(--color-text-dark, #042a2a) !important;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--color-text-dark, #042a2a) !important;
  }

  .ant-tabs-ink-bar,
  .ant-tabs-ink-bar-animated {
    background: var(--color-primary) !important;
    background-color: var(--color-primary) !important;
  }

  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-nav::before {
    border-bottom: 1px solid #f0f0f0 !important;
  }

  &.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
    padding: 20px 0;
  }

  &.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
    padding: 8px 0;
  }
`;
